module.exports = __webpack_public_path__ + "static/media/mission.d63b75aa.svg";